import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const colors = {
    orange: 'border-r-orange-100',
};
const sizes = {
    lg: {
        bottom: 'border-b-[30px]',
        right: 'border-r-[30px]',
    },
    md: {
        bottom: 'border-b-[10px] md:border-b-[16px]',
        right: 'border-r-[10px] md:border-r-[16px]',
    },
};
export const ObliqueBadge = (props) => {
    const { children, className = '', color = 'orange', isShowBadge = true, size = 'md', } = props;
    return (_jsxs("div", Object.assign({ className: clsx('relative', className) }, { children: [isShowBadge && (_jsx("span", { className: clsx('absolute top-0 right-0', 'border-solid border-l-0 border-t-0', [sizes[size].bottom, 'border-b-transparent'], [sizes[size].right, colors[color]], 'z-10') })), children] })));
};
